import { Entry } from 'contentful'

import {
  TextInputType,
  TypeComponentTextInput,
  TypeComponentTextInputFields,
} from '../../../lib/types/component-text-input'

export const aiDetectorYOffset = -100

export const focusTimeout = 200

export const anonymousSubmitLimit = 2
export const anonymousSubmitPeriod = 24 * 60 * 60 * 1000

export const faqSectionIdPrefix = 'sectionFaq'

export const aiDetectorQuestionStructure: TypeComponentTextInput = {
  fields: {
    internalName: 'ai-detector',
    name: 'AI Detector Text Input',
    placeholder: 'Type or paste your text.',
    type: TextInputType.Text,
    isRequired: true,
    maxLength: 10000,
    minCharacterLimit: 200,
    useWordLimit: false,
  },
  sys: {
    type: 'Entry',
    id: 'aiDetectorId',
    createdAt: '2024-07-22T00:00:00.000Z',
    updatedAt: '2024-07-22T00:00:00.000Z',
    locale: 'en-US',
    contentType: {
      sys: {
        type: 'Link',
        linkType: 'ContentType',
        id: 'sectionDynamicAIDetector',
      },
    },
  },
  metadata: {
    tags: [],
  },
  toPlainObject: function (): object {
    throw new Error('Function not implemented.')
  },
  update: function (): Promise<Entry<TypeComponentTextInputFields>> {
    throw new Error('Function not implemented.')
  },
}

export type AIDetectorState = 'initial' | 'loading' | 'error' | 'done'

export const AIDetectorValuePropList = [
  'Cite AI sources instantly',
  'Format citations in MLA, APA, or Chicago style in a click',
  'Catch accidental plagiarism',
]
